import { FC } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { TopCallItem } from '@/entities/dashboards';
import { DASHBOARD_BLOCK_SCROLL_CLASS } from '@/shared/lib';
import { EmptyState } from '@/shared/ui';
import { TopCallLink } from './parts/TopCallLink';

type Props = {
  title: string;
  calls: TopCallItem[];
  /** true — выделять карточки красным (для худших) */
  negative?: boolean;
  /** Открытие диалога звонка; `openInNewTab` — пользователь кликнул с shift */
  onOpenCall: (conversationId: number, openInNewTab: boolean) => void;
};

/** Карточка со списком топ-5 звонков (лучших или худших). */
export const TopCallsCard: FC<Props> = ({ title, calls, negative, onOpenCall }) => (
  <Card>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
    </CardHeader>
    <CardContent>
      {calls.length === 0 ? (
        <EmptyState />
      ) : (
        <div className={`${DASHBOARD_BLOCK_SCROLL_CLASS} flex flex-col gap-2`}>
          {calls.map((call) => (
            <TopCallLink key={call.id} call={call} negative={negative} onOpen={onOpenCall} />
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
